module.exports = __webpack_public_path__ + "asset/img/shoplist-no-data-spe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/shoplist-no-data-spe.svg
// module id = 976
// module chunks = 38 43